export default __webpack_public_path__ + "231e8a4c15cf54d3cc46b16a33df2854.png";